import styled from 'styled-components'

import {
    RowFlex,
    ColumnFlex,
    hideWhenNoChildren,
} from 'components/common/genericStyles'

import { tabDesktopBreakpoint } from '../../constants'

export const Options = styled.div`
    width: inherit;
    ${RowFlex}
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
`

export const ChoiceFlexContainer = styled.div`
    ${ColumnFlex}
    align-items: flex-start;
    justify-content: center;
    width: inherit;
    margin-bottom: 1.38vh;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        width: 47%;
        margin-bottom: 2.56%;
    }
    ${hideWhenNoChildren}
`

export const TextContainer = styled.div`
    width: inherit;
    min-height: 19px;
`
